import React from 'react';
import './header.scss';
import healthlineLogo from '../../assets/healthline-logo.svg';

class Header extends React.Component {
    render() {
        const { site } = this.props;

        return (
            <header id="header" className={`container-fluid-info  ${site}`}>
                <div id="logo" />
            </header>
        )
    }
}

export default Header;